import api, { TipoOptions } from '@app/api/api';

const controller = "crfTipoProjetoGrupo";

export interface CrfTipoProjeto {
  id: string;
  data: TPData;
}

export interface TPData {
  nome: string;
  codigo: number;
}

//#region Grupo

export const getCfTipoProjetoGrupoById = (id: string) =>
  api.get<CrfTipoProjeto[]>(`${controller}/${id}`);

export const getCfTipoProjetoGrupoByCodigo = (codigo: string) =>
  api.get<CrfTipoProjeto[]>(`${controller}/null?codigo=${codigo}`);

export const getAllCfTipoProjetoGrupos = () => api.get<CrfTipoProjeto[]>(`${controller}`);
export const getAllCfTipoProjetoGruposOptions = () =>
  api.get<TipoOptions[]>(controller)
    .then((values: any) => (values || []).map((v: any) => ({ text: v.data.nome, value: v.id.toString() })));

export const createCfTipoProjetoGrupo = (tipoProjeto: Omit<TPData, 'codigo'>) =>
  api.post<CrfTipoProjeto>(`${controller}`, tipoProjeto);

export const updateCfTipoProjetoGrupo = (tipoProjeto: any) => {
  const data = {
    id: tipoProjeto.id,
    nome: tipoProjeto.data.nome,
  };

  return api
    .put<boolean>(`${controller}/${data.id}`, data)
    .then(result => true)
    .catch(err => false);
};

export const deleteCfTipoProjetoGrupo = (id: string) => api.delete(`${controller}/${id}`);
//#endregion

